import { Route } from '@angular/router';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseCardModule } from '@fuse/components/card';
import { FuseAlertModule } from '@fuse/components/alert';
import { SharedModule } from 'app/shared/shared.module';
import { DirectivesModule } from 'app/directives/directive.module';
import { EditorPlantillaComponent } from './editor-plantilla.component';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { EditorModule } from '@tinymce/tinymce-angular';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


export const routes: Route[] = [
    {
        path: '',
        component: EditorPlantillaComponent,
    },
];

@NgModule({
    declarations: [EditorPlantillaComponent],
    imports: [
        RouterModule.forChild(routes),
        MatIconModule,
        CommonModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        SharedModule,
        FuseCardModule,
        FuseAlertModule,
        DirectivesModule,
        MatSlideToggleModule,
        EditorModule,
        MatProgressSpinnerModule,
    ],
})
export class EditorPlantillaModule {}
